import dynamicColors from "../constants/dynamicColors";

import { CHANGE_THEME_COLORS } from "../actions/themeColors";

export default function themeColors(state = dynamicColors, action) {
  switch (action.type) {
    case CHANGE_THEME_COLORS:
      return {
        ...state,
        ...action.themeColors
      };

    default:
      return state;
  }
}
